import { gql } from "@apollo/client"

export const CHECKOUT_PAYMENT_CREATE = gql`
  mutation checkoutPaymentCreate($checkoutId: ID!, $paymentGateway: String!, $amount: PositiveDecimal) {
    checkoutPaymentCreate(id: $checkoutId, input: { gateway: $paymentGateway, amount: $amount }) {
      payment {
        id
        chargeStatus
      }
      errors {
        field
        message
      }
    }
  }
`
